var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM4.44922 4.63819L5.31322 3.77419V3.74219H10.4972L11.3612 4.60619V6.33419H8.76922V5.47019H7.04122V7.19819H10.4652L11.3292 8.06219V11.5182L10.4652 12.3822H5.31322L4.44922 11.5182V9.79019H7.04122V10.6542H8.73722V8.92619H5.31322L4.44922 8.06219V4.63819Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSand);
export default __webpack_public_path__ + "static/media/sand.87b96ba7e5722832199d5f5f9f87a7b5.svg";
export { ForwardRef as ReactComponent };